// extracted by mini-css-extract-plugin
export default {"content":"ResponseFailure_content__WRPca","content__message":"ResponseFailure_content__message__-qqZ2"};